function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_9",
  "data-name": "Ellipse 9",
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#eeeff3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_251",
  "data-name": "Group 251",
  transform: "translate(9 9)"
}, /*#__PURE__*/React.createElement("g", {
  id: "intake",
  transform: "translate(0.744 0.743)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_71",
  "data-name": "Path 71",
  d: "M6.938,9H6a.4.4,0,0,0-.341.439v.746A.4.4,0,0,0,6,10.622h.943a.4.4,0,0,0,.341-.439V9.437A.41.41,0,0,0,6.938,9ZM4.1,9H3.153a.4.4,0,0,0-.341.439v.746a.4.4,0,0,0,.341.439H4.1a.4.4,0,0,0,.341-.439V9.437A.41.41,0,0,0,4.1,9ZM6.938,6.562H6A.4.4,0,0,0,5.654,7v.746A.4.4,0,0,0,6,8.186h.943a.4.4,0,0,0,.341-.439V7A.41.41,0,0,0,6.938,6.562Zm-2.842,0H3.153A.4.4,0,0,0,2.812,7v.746a.4.4,0,0,0,.341.439H4.1a.4.4,0,0,0,.341-.439V7A.41.41,0,0,0,4.1,6.562Zm5.684,0H8.837A.4.4,0,0,0,8.5,7v.746a.4.4,0,0,0,.341.439h.943a.4.4,0,0,0,.341-.439V7A.41.41,0,0,0,9.779,6.562Z",
  transform: "translate(-0.377 -0.879)",
  fill: "#f8202d",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_72",
  "data-name": "Path 72",
  d: "M11.884,8.057V2.523a1.408,1.408,0,0,0-.356-.934V1.575h-.014A1.384,1.384,0,0,0,10.475,1.1H9.449V.474A.466.466,0,0,0,8.984,0h-.7a.466.466,0,0,0-.465.474V1.1H4.048V.474A.466.466,0,0,0,3.583,0h-.7A.466.466,0,0,0,2.42.474V1.1H1.395a1.384,1.384,0,0,0-1.039.474v.014A1.409,1.409,0,0,0,0,2.523v7.6a1.414,1.414,0,0,0,1.395,1.422h6.55a2.669,2.669,0,0,0,2.366,1.45,2.736,2.736,0,0,0,1.573-4.934Zm-4.253,2.2a2.761,2.761,0,0,0,.027.335H1.395A.466.466,0,0,1,.93,10.12v-5.8H10.94v3.29a2.363,2.363,0,0,0-.629-.084A2.711,2.711,0,0,0,7.631,10.259Zm3.788-.279-1.108,1.213a.358.358,0,0,1-.52,0l-.656-.725a.358.358,0,0,1,.014-.5.342.342,0,0,1,.492.014l.41.446.848-.934a.342.342,0,0,1,.492-.014A.347.347,0,0,1,11.419,9.98Z",
  transform: "translate(0)",
  fill: "#f8202d"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_114",
  "data-name": "Rectangle 114",
  width: 14,
  height: 14,
  fill: "none"
}));

var SvgCalendarRed = function SvgCalendarRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2733",
    "data-name": "Group 2733",
    width: 42,
    height: 42,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-red.1d09831c.svg";
export { ForwardRef as ReactComponent };